export const NAMESPACE = "PortalPreviewProfile";

export const TABS = {
  LIGHT_MODE: "light_mode",
  DARK_MODE: "dark_mode"
};
